import { ColorSchema } from 'src/theme/palette';

export const getPartyColor = (registered_party?: string | number): ColorSchema => {
  if (!registered_party) {
    return 'warning';
  }

  const party = registered_party?.toString().trim().toLowerCase();

  const colors: { [key: string]: string } = {
    republican: 'error',
    'modeled republican': 'error',
    '1': 'error',
    '2': 'error',

    democrat: 'info',
    democratic: 'info',
    'modeled democrat': 'info',
    '4': 'info',
    '5': 'info',

    'strong gop': 'error',
    'lean gop': 'error',
    'strong democrat': 'info',
    'lean democrat': 'info',
    swing: 'warning',

    'unaffiliated/dts': 'secondary',
    'modeled independent/unaffiliated': 'warning',
    'independent/other': 'warning',
  };

  if (!party || party === '') {
    return 'warning';
  }

  return (colors[party] || 'warning') as ColorSchema;
};
